<ion-content style="--background: white;">

    <ion-row class="ion-padding">
        <ion-col size="12">
            <div class="ts-h3-sans">{{ 'Un_consiglio_per_te' | translate }}</div>
            <p class="ts-body mt-sm" [innerHTML]="'Apri_su_mobile' | translate"></p>
            <div class="d-flex ion-justify-content-center mt-md">
                <img style="width: 180px;height: 180px;" [src]="'./assets/qrcode.png'">
            </div>

        </ion-col>
        <ion-col size="12" class="d-flex ion-justify-content-center pt-lg">
            <ion-button (click)="onClose()" fill="clear">Continua</ion-button>
        </ion-col>
    </ion-row>
</ion-content>
